import React from 'react';
import { ChipBookingStatus } from 'components/common/Deal/ChipBookingStatus/ChipBookingStatus';
import { Size } from 'lib/Chip/Chip.types';
import { ProgrammaticAndDirectSalesBookingStatus } from 'components/common/types/Deal.types';

export interface StatusRendererProps {
  campaignStatus: ProgrammaticAndDirectSalesBookingStatus | null;
}

export const StatusRenderer: React.FC<StatusRendererProps> = ({ campaignStatus }) => {
  if (!campaignStatus) return null;

  return (
    <ChipBookingStatus
      status={campaignStatus}
      size={Size.MEDIUM}
      dataTestId={`campaign-status-chip-${campaignStatus}`}
    />
  );
};
